/**
 * Stylitics PDP Widget Styles
 * Injected at runtime into document.head by StyliticWidgetPDP.
 * These target Stylitics SDK-rendered class names (global, not CSS Modules).
 */
const STYLITICS_STYLES = `
/* === Container Styles === */
#shopLookContainer,
#shopSetContainer,
#stylitics-composer-container {
    text-align: center;
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 40px;
}

/* === Shared Base Font === */
.stylitics-dimension-collage-base *,
.stylitics-ms-widget-root *,
.stylitics-grid-base * {
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
}

/* === Shop The Look (Dimension Collage) === */
.stylitics-dimension-collage-base * {
    font-size: 14px !important;
    line-height: 20px !important;
}

.stylitics-dimension-collage-card {
    background-color: white !important;
}

.stylitics-dimension-collage-item-name {
    font-family: Arial !important;
    color: #202020 !important;
    font-weight: 400 !important;
}

.stylitics-dimension-collage-item-cta {
    font-family: Arial !important;
}

.stylitics-dimension-collage-card-footer {
    font-weight: 600 !important;
}

.stylitics-dimension-collage-modal-heading {
    font-size: 16px !important;
    line-height: 28px !important;
    font-weight: 400 !important;
}

.stylitics-container .stylitics-card {
    width: calc((100% + 48px) / 2.275 - 16px) !important;
}

.stylitics-modal-scroll > .stylitics-modal {
    z-index: 99999991 !important;
}

/* === Shop The Set (Matching Set) === */
.stylitics-ms-widget-root * {
    font-size: 16px !important;
    line-height: 24px !important;
}

.stylitics-ms-is-mobile * {
    font-size: 14px !important;
    line-height: 20px !important;
}

.stylitics-ms-set-item-details {
    text-align: left !important;
}

.stylitics-ms-set-item-name {
    font-weight: 400 !important;
    color: #202020 !important;
}

.stylitics-ms-set-item-position {
    color: black !important;
}

#shopSetContainer .stylitics-ui-carousel-card {
    grid-gap: 24px !important;
}

/* === Mix and Match (Composer Grid) === */
.stylitics-grid-base * {
    font-size: 14px !important;
    line-height: 20px !important;
}

div#stylitics-composer-container .stylitics-grid-layout {
    margin-bottom: 30px !important;
}

#stylitics-composer-container .stylitics-grid-counter-heading {
    text-align: left !important;
}

#stylitics-composer-container .stylitics-grid-layout .stylitics-grid-item-info-name {
    font-weight: 400 !important;
    padding: 0;
    text-align: center;
    height: auto !important;
    min-height: fit-content !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
}

#stylitics-composer-container .stylitics-grid-layout p.stylitics-ui-price {
    padding: 0;
    text-align: center;
    height: auto !important;
    min-height: fit-content !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
}

#stylitics-composer-container .stylitics-grid-layout .stylitics-ui-sale-price {
    color: rgb(231, 19, 36);
}

#stylitics-composer-container .stylitics-grid-layout .stylitics-ui-regular-price-slashed {
    color: #000000;
}

.stylitics-grid-item-non-editorial.stylitics-grid-item-static.stylitics-grid-item-anchor-item img.stylitics-ui-image {
    --max-size: 100% !important;
    max-height: 100% !important;
    max-width: 100% !important;
}

#stylitics-composer-container .stylitics-grid-layout .stylitics-ui-carousel-card-list {
    --column-width: calc((100% - 0px) / 1.1) !important;
}

#stylitics-composer-container .stylitics-grid-layout li {
    height: auto !important;
    min-height: fit-content !important;
}

#stylitics-composer-container .t-red .stylitics-item-sale-price {
    color: red !important;
}

@media (max-width: 768px), (pointer: coarse) {
    div#stylitics-composer-container div.stylitics-grid-layout {
        height: auto !important;
        min-height: fit-content !important;
        max-height: none !important;
        overflow: visible !important;
        display: block !important;
    }
}

/* === Shared Item Name === */
.stylitics-ui-item-info-name {
    text-align: left !important;
}

.stylitics-classic-item-name,
.stylitics-ui-item-info-name p {
    color: #202020 !important;
    font-weight: 400 !important;
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
}

/* === Shared Pricing === */
.stylitics-ui-price,
.stylitics-item-price {
    color: #202020 !important;
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
    font-weight: 700 !important;
}

.stylitics-item-regular-price,
.stylitics-ui-regular-price {
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
    font-weight: 700 !important;
    color: #202020 !important;
}

.stylitics-item-sale-price,
.stylitics-ui-sale-price {
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
    font-weight: 700 !important;
    color: #202020 !important;
}

.stylitics-ui-regular-price-slashed,
.stylitics-item-regular-price-slashed {
    font-weight: 400 !important;
    text-decoration: line-through !important;
    color: #666666 !important;
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
}

.promotional-sale-price {
    color: #E71324 !important;
    font-family: 'OPEN SANS', OpenSans, Helvetica, arial, sans-serif !important;
    font-weight: 700 !important;
}

.promotional-text,
.couponText {
    font-style: italic !important;
    font-weight: 400 !important;
    color: #E71324 !important;
}

/* === Shared Button === */
.stylitics-ui-button {
    border-color: #999999 !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
}

/* === Shared CTA === */
.stylitics-classic-item-cta,
.stylitics-cta {
    border: 1px solid #E4E4E4 !important;
    border-radius: 3.46px;
    color: #202020 !important;
}

/* === Responsive === */
@media only screen and (max-width: 600px) {
    .stylitics-container .stylitics-card {
        width: calc((100% + 48px) / 1.275 - 16px) !important;
    }
}
`;

export default STYLITICS_STYLES;
